var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassDis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3693 1.00063C22.1626 5.51758 17.8985 8.57873 13.0001 8.57873M13.0001 8.57873C8.10156 8.57873 3.83745 5.51758 1.63129 1M13.0001 8.57873V12.3682M22.375 4.05888L25 6.68399M18.3438 7.27603L19.9475 10.4735M3.62501 4.05888L1 6.68399M7.65628 7.27603L6.05266 10.4735",
    stroke: "#C4C4C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassDis);
export default __webpack_public_path__ + "static/media/pass-dis.34b3ba0c5d24b1071dbca337af0271fe.svg";
export { ForwardRef as ReactComponent };